export enum SearchBarType {
  DatePicker = "DatePicker",
  Input = "Input",
  Select = "Select",
}
